export const environment = {
  fakeForm: false,
  firebase: {
    projectId: 'tempo-85b92',
    appId: '1:1042899946632:web:f4dcf1f994ea0abf52233d',
    storageBucket: 'tempo-85b92.appspot.com',
    apiKey: 'AIzaSyDaybaAq2k8MhXKdGVWg-5ViziZrUhXZGg',
    authDomain: 'app.aitempo.online',
    messagingSenderId: '1042899946632',
    measurementId: 'G-Y4CJPLT2GB',
  },
  production: true,
  trainingRedeem: false,
  ALGOD_ENDPOINT: "https://mainnet-api.algonode.cloud",
  ALGOD_APIKEY: "btZ6zsW3Ni9H4dVLLsK225A9UGUd8rPk7oF5GRMO",
  CREATOR_ADDRESS: "E6T7XNNT6J4XY77UJBNMUJGYOEHE7O65GKDD4FDBOWTEYIRXYHBMSA7QOM",
  ASSETID_OLD: 1071895618,
  ASSETID: 2146052273,
  customerCareUid: "xCIqbLdoyvgBpmQPK9CiHwfcDuz1",
  GOOGLE_API_KEY: "AIzaSyBbRhOqKgn6-vN2LwiJ3KS7WMCbvRzZx6U",
  FACEBOOK_ACCESS_TOKEN: "1349629123222875|76b0b1729739528f254e0d194bd317f8",
  customerCareEmail: "assistenza@aitempo.online"
};
